import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBikeRepairStationinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M18 46h2.4c.884 0 1.6.768 1.6 1.714v2.572c0 .946-.716 1.714-1.6 1.714H18m29 0h-2.4c-.884 0-1.6-.768-1.6-1.714v-2.572c0-.946.716-1.714 1.6-1.714H47m-25 3h21",
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("circle", {
				strokeLinecap: "square",
				transform: "matrix(-1 0 0 1 90 0)",
				cx: 45,
				cy: 33,
				r: 7
			}),
			/* @__PURE__ */ _jsx("circle", {
				strokeLinecap: "square",
				transform: "matrix(-1 0 0 1 38 0)",
				cx: 19,
				cy: 33,
				r: 7
			}),
			/* @__PURE__ */ _jsx("path", { d: "M23 16l7.5 17" }),
			/* @__PURE__ */ _jsx("path", {
				d: "M26 16h-6m17 0h2.252a1 1 0 0 1 .96.718L45 33",
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("path", {
				strokeLinecap: "square",
				d: "M41 21H25l-6 12h11.674z"
			}),
			/* @__PURE__ */ _jsx("rect", {
				strokeLinecap: "square",
				x: 5,
				y: 5,
				width: 54,
				height: 54,
				rx: 4
			})
		]
	})
});
export default SvgBikeRepairStationinline;
